/**
 * The inventory bar.
 *
 * Kate asked to be able to "look what you have in your inventory", and she plays on an
 * iPad, so it is always on screen and tappable rather than hidden behind a key.
 */
import type { Inventory } from '../economy/inventory'

export class InventoryBar {
  private readonly root: HTMLDivElement
  private readonly inventory: Inventory
  /** Tapping a slot uses it — eating meat, for now. */
  onUse: ((id: string) => void) | null = null

  constructor(parent: HTMLElement, inventory: Inventory) {
    this.inventory = inventory
    this.root = document.createElement('div')
    this.root.className = 'inventory'
    parent.append(this.root)
    this.render()
  }

  render(): void {
    const items = this.inventory.all
    this.root.innerHTML = ''
    this.root.dataset.empty = items.length ? 'no' : 'yes'

    if (!items.length) {
      const empty = document.createElement('p')
      empty.className = 'inventory-empty'
      empty.textContent = 'Inventory empty'
      this.root.append(empty)
      return
    }

    items.forEach((item, i) => {
      const slot = document.createElement('button')
      slot.className = `inventory-slot${i === this.inventory.selected ? ' is-selected' : ''}`
      slot.innerHTML = `
        <span class="inventory-icon">${item.icon}</span>
        <span class="inventory-count">${item.count}</span>
        <span class="inventory-label">${item.label}</span>`
      slot.addEventListener('click', () => {
        this.inventory.select(i)
        this.onUse?.(item.id)
        this.render()
      })
      this.root.append(slot)
    })
  }
}
